import React from 'react';
import TemplateHeader from './components/template-header';
import { ECndnType } from '@/enums/ECndn';
import TemplateCndnInfoSecond from './components/template-cndn-freeform-info-second';
import TemplateCndnInfoItem from './components/template-cndn-freeform-info-item';
import TemplateFooter from './components/template-footer';
import { getCndnTypeName } from '@/helpers/cndnHelper';
import { ICndnFreeForm } from '@/interfaces/cndnFreeForm';
import TemplateCndnFreeFormInfo from './components/template-cndn-freeform-info';

interface IProps {
  cndn: ICndnFreeForm;
}

const TM29 = ({ cndn }: IProps) => {
  const docNameTH = cndn.type == ECndnType.CREDIT ? 'ใบลดหนี้' : 'ใบเพิ่มหนี้';
  const docNameEN =
    cndn.type == ECndnType.CREDIT ? 'Credit Note' : 'Debit Note';
  const desc = cndn?.taxRate > 0 ? 'ใบกำกับภาษี' : 'ไม่ใช่ใบกำกับภาษี';
  const orders = cndn?.manualCreditDebitNoteItems?.filter(c => !!c.isOrderItem);
  const items = cndn?.manualCreditDebitNoteItems?.filter(c => !c.isOrderItem);
  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        pageBreakBefore: 'always',
      }}
    >
      <TemplateHeader
        description={desc}
        titleEn={docNameEN}
        titleTh={docNameTH}
        businessUnitLogo={cndn?.businessUnit?.mediaId || 0}
        otherDescription={'สำเนา'}
      />
      <TemplateCndnFreeFormInfo cndn={cndn} />
      <TemplateCndnInfoSecond cndn={cndn} />
      <p className="mt-4 font-bold">รายการตามใบแจ้งหนี้เดิม</p>
      <TemplateCndnInfoItem data={cndn} items={orders} showFooter={false} />
      <p className="mt-4 font-bold">{`รายการ${getCndnTypeName(cndn.type)}`}</p>
      <TemplateCndnInfoItem data={cndn} items={items} showFooter />
      <TemplateFooter
        paidInfoTemplate="TM24"
        footerTextLeft="ต้นฉบับ - ORIGINAL"
        footerTextRight="ต้นฉบับ - นำกลับบริษัท"
        referenceNo1={cndn?.customer?.reference1 || ''}
        referenceNo2={cndn?.customer?.reference2 || ''}
        amount={cndn?.grandTotalAmount}
        customerCode={cndn?.customer?.code || ''}
        ivNo={cndn?.ivNo || ''}
        isReceive={false}
        showFooter={false}
        isReceipt
        docNo={cndn?.code}
        isMultiPage={false}
        isCndn
        signature={cndn?.businessUnit?.signatureMediaId || 0}
      />
    </div>
  );
};

export default TM29;
